module.exports = __webpack_public_path__ + "img/HappyPhoto41.5ccf4046.jpeg";